<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="disabled"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
  </ul>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>

<!-- Employee Dashboard -->
<div class="section-bottom" *ngIf="dashboardService.client.isMatrixTools">
  <employee-dashboard></employee-dashboard>
</div>

<!-- Dashboard Thumbnail Buttons -->
<div class="container-fluid navigation-buttons">
  <div class="row">
    <div class="col-md-6">
      <client-info-panel></client-info-panel>
    </div>
    <div class="col-md-6">
      <thumbnail-button label="Change Log" link="/change-log" [website]="website" [hasSettings]="false" [error]="dashboardService.changeLogErrors"
        [warning]="!dashboardService.changeLogErrors && dashboardService.client.isSoftwareServiceRenewalSoon ? 'Software Service Renewal Due Soon' : ''">
      </thumbnail-button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <thumbnail-button backgroundImage="/eCommerce/MatrixTools/website.png" link="/website" [website]="website"
        [softwareService]="websiteService" [hasSettings]="false"
        [warning]="dashboardService.client.isSoftwareServiceRenewalSoon ? 'Software Service Renewal Due Soon' : ''">
      </thumbnail-button>      
    </div>
    <div class="col-md-4">
      <thumbnail-button backgroundImage="/eCommerce/MatrixTools/seo.png" link="/seo" [website]="website"
        [softwareService]="seoService" [hasSettings]="true" 
        [warning]="dashboardService.client.isSoftwareServiceRenewalSoon ? 'Software Service Renewal Due Soon' : ''">
      </thumbnail-button>
    </div>
    <div class="col-md-4">
      <thumbnail-button backgroundImage="/eCommerce/MatrixTools/Social Media.png" link="/smm" [website]="website"
        [softwareService]="smmService" [hasSettings]="false"
        [warning]="dashboardService.client.isSoftwareServiceRenewalSoon ? 'Software Service Renewal Due Soon' : ''">
      </thumbnail-button>
    </div>
  </div>
</div>
